import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=5ae382c1"
import script from "./realtime.vue?vue&type=script&lang=js"
export * from "./realtime.vue?vue&type=script&lang=js"
import style0 from "./realtime.vue?vue&type=style&index=0&id=5ae382c1&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports